// extracted by mini-css-extract-plugin
module.exports = {"main":"TopBanner_main___ds8a","link":"TopBanner_link__6TOoR"};